/** Ordered fallbacks for the required base city manifest. */
export const RUNTIME_TILE_BASE_MANIFEST_URLS = Object.freeze([
  "/world/generated/vilnius-wide/manifest.json",
  "/world/development/m2/manifest.json",
] as const);

/**
 * Sparse official-data continuations beyond the broad city envelope. Missing
 * extension artifacts are tolerated so the small checked-in M2 fixture stays
 * runnable, while production/local full-world packages can add them without
 * duplicating the 15k-cell base export.
 */
export const RUNTIME_TILE_EXTENSION_MANIFEST_URLS = Object.freeze([
  "/world/generated/vilnius-north-destinations/manifest.json",
  "/world/generated/vilnius-east-destinations/manifest.json",
] as const);
